export interface CmsProtectionStartSummaryPanelBoilers {
  protectionStartSummaryPanelBodyBoilers: string;
  protectionStartSummaryPanelTitleBoilers: string;
}
